// packages/editor/src/slot-grammar/slot-types.ts
//
// SlotConfig — the structured representation of a :::slot[name]{attrs}:::
// directive. Used by parse-slot (mdast → SlotConfig), serialize-slot
// (SlotConfig → directive string), and SlotInspector (form-bound state).
//
// E2 stores slot attributes verbatim; no semantic validation against
// slot-schemas.ts (Phase E3). The Zod schema here only enforces shape +
// known enum values. Unknown `schema` strings pass through as 'other'
// per E2 design.

import { z } from 'zod';

export const SourceEnum = z.enum(['auto', 'human', 'slash-only']);
export const ReviewerEnum = z.enum(['none', 'compliance', 'chef', 'admin']);

export const SlotConfigSchema = z.object({
  name: z.string().min(1, 'slot name required'),
  schema: z.string().min(1).default('Markdown'),
  source: SourceEnum.default('human'),
  reviewer: ReviewerEnum.default('none'),
  trigger: z.string().optional(),
  slash: z.array(z.string()).default([]),
  maxWords: z.number().int().positive().optional(),
  maxBytes: z.number().int().positive().optional(),
  maxItems: z.number().int().positive().optional(),
  default: z.string().optional(),
});

export type SlotConfig = z.infer<typeof SlotConfigSchema>;
